import React, { useEffect, useState } from "react";
import "./Footer.css";
import data from "./Footer.json";
import { Link } from "react-router-dom";

const Footer = () => {
  const [links, setLinks] = useState([]);

  useEffect(() => {
    if (data.container1 && data.container1.data) {
      setLinks(data.container1.data);
    }
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };
  return (
    <div className="main-container footer">
      <nav>
        <div>
          <img
            className="launchfooterLogo"
            src="assets/images/launchNttdataLogo.png"
            alt="logo"
          />
        </div>

        <ul>
          <li>
            <Link to="/" onClick={scrollToTop}>
              Home
            </Link>
          </li>
          {links.map((item) => (
            <li key={item.id}>
              <a href={item.routingurl} target="_blank" rel="noreferrer">
                {item.footername}
              </a>
            </li>
          ))}
        </ul>
      </nav>

      <div className="verticle-line"></div>

      <nav>
        <div>
          <img
            className="nttdataLogoFooter"
            src="assets/images/nttdataLogo.png"
            alt="logo"
          />
        </div>
        <div className="social-icons">
          <a href="#">
            <img src="assets/images/twitter.png" alt="twitter" />
          </a>
          <a href="#">
            <img src="assets/images/linkedin.png" alt="linkedin" />
          </a>
          <a href="#">
            <img src="assets/images/facebook.png" alt="facebook" />
          </a>
          <a href="#">
            <img src="assets/images/socialmedia.png" alt="socialmedia" />
          </a>
          <a href="#">
            <img src="assets/images/instagram.png" alt="instagram" />
          </a>
        </div>
      </nav>
      <nav className="col-xl-12 lg-10 md-9 sm-8 col-7">
        <div>
          <ul className="listfoot">
            {data.container2.data.map((item) => (
              <div key={item.id}>
                <li>
                  <Link to={item.routingurl}>{item.footername}</Link>
                </li>
              </div>
            ))}
          </ul>
        </div>
      </nav>
    </div>
  );
};
export default Footer;
